import { navigateTo } from 'gatsby-link'
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import Page from '../components/page'
import theme from '../utils/theme'

const Label = styled.label`
  display: block;

  &:after {
    content: "*";
    color: #9b0031;
  }
`

const InputGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -1.5rem;
`

const InputContainer = styled.div`
  padding-left: 1.5rem;
  width: 100%;
  
  @media (min-width: 32rem) {
    width: 50%;
  }
`

const Input = styled.input`
  width: 100%;
  margin-bottom: 1rem;
  border: 1px solid ${theme.colors.muted} !important;
  border-radius: 0.125rem;
  font-family: ${theme.fonts.sans} !important;
  font-weight: bold;

  &:focus {
    outline: 2px solid ${theme.colors.teal};
  }
`

const Textarea = styled.textarea`
  width: 100%;
  margin-bottom: 1rem;
  border: 1px solid ${theme.colors.muted};
  border-radius: 0.125rem;
  font-family: ${theme.fonts.sans} !important;
  font-weight: bold;

  &:focus {
    outline: 1px solid ${theme.colors.teal};
  }
`

const Button = styled.button`
  font-family: ${theme.fonts.sans};
`

function encode(data) {
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
}

class ContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state })
    })
      .then(() => navigateTo('/thanks/'))
      .catch(error => alert(error))

    e.preventDefault()
  }

  render() {
    return (
      <Page>
        <Helmet>
          <title>Contact {this.props.data.site.siteMetadata.title}</title>
        </Helmet>
        <h1>
          Contact Us
        </h1>
        <p>
          {this.props.data.site.siteMetadata.title} is a family owned and operated business that delights in offering the hands-on benefits and personal attention of a small company while maintaining the full range of professional services presented by larger corporations.
        </p>
        <p>
          <strong>
            We look forward to hearing from you!
          </strong>
        </p>
        <hr/>
        <p>
          <strong style={{display: 'inline-block', width: '5rem'}}>
            Phone
          </strong>
          <span style={{fontFamily: theme.fonts.sans}}>
            {this.props.data.site.siteMetadata.phone}
          </span>
        </p>
        <p>
          <strong style={{display: 'inline-block', width: '5rem'}}>
            Email
          </strong>
          <span style={{fontFamily: theme.fonts.sans}}>
            {this.props.data.site.siteMetadata.email}
          </span>
        </p>
        <hr/>
        <p>
          <strong>
            Send us a message.
          </strong>
          <br/>
          <small style={{color: theme.colors.muted}}> 
            Please fill out all of the form fields.
          </small>
        </p>
        <form
          name="contact"
          method="post"
          action="/thanks/"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          <div hidden>
            <Label htmlFor="honey">
              Honey
            </Label>
            <Input
              name="bot-field"
              id="honey"
              onChange={this.handleChange}
            />
          </div>
          <InputGrid>
            <InputContainer>
              <Label htmlFor="firstName">
                First name
              </Label>
              <Input
                type="text"
                name="firstName"
                id="firstName"
                onChange={this.handleChange}
                required
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="lastName">
                Last name
              </Label>
              <Input
                type="text"
                name="lastName"
                id="lastName"
                onChange={this.handleChange}
                required
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="email">
                Email
              </Label>
              <Input
                type="email"
                name="email"
                id="email"
                onChange={this.handleChange}
                required
              />
            </InputContainer>
            <InputContainer>
              <Label htmlFor="phone">
                Phone
              </Label>
              <Input
                type="phone"
                name="phone"
                id="phone"
                onChange={this.handleChange}
                required
              />
            </InputContainer>
          </InputGrid>
          <div>
            <Label htmlFor="message">
              Message
            </Label>
            <Textarea
              name="message"
              id="message"
              onChange={this.handleChange}
              required
            />
          </div>
          <div>
            <Button type="submit">
              Send Message
            </Button>
          </div>
        </form>
      </Page>
    )
  }
}

export default ContactPage

export const query = graphql`
  query ContactQuery {
    site {
      siteMetadata {
        title
        phone
        email
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js